import { CheckCircleOutlined } from '@ant-design/icons';
import type { ReactNode } from 'react';
import { ScopeButton } from '../components/buttons';
import { CardTitleLargeSpan } from '../components/formSpans';

export type BeforeYouScanStep = {
  id: string;
  label: ReactNode;
  completed: boolean;
  ctaLabel: string;
  onCta: () => void;
  disabled?: boolean;
  muted?: boolean;
};

export type BeforeYouScanChecklistProps = {
  title: string;
  subtitle: string;
  doneLabel: string;
  steps: BeforeYouScanStep[];
  illustrationSrc?: string;
  illustrationAlt?: string;
};

export const BeforeYouScanChecklist = ({
  title,
  subtitle,
  doneLabel,
  steps,
  illustrationSrc,
  illustrationAlt = '',
}: BeforeYouScanChecklistProps) => (
  <div className="before-you-scan-card">
    <div className="before-you-scan-layout">
      <div className="before-you-scan-steps">
        <h2 className="before-you-scan-title">
          <CardTitleLargeSpan style={{ display: 'block', marginBottom: 0 }}>
            {title}
          </CardTitleLargeSpan>
        </h2>
        <p className="before-you-scan-subtitle">{subtitle}</p>
        <ul className="before-you-scan-list">
          {steps.map((step, index) => (
            <li key={step.id}>
              {index > 0 ? (
                <div className="before-you-scan-connector" aria-hidden />
              ) : null}
              <div className="before-you-scan-step">
                <div className="before-you-scan-step-number">{index + 1}</div>
                <div className="before-you-scan-step-content">
                  <span
                    className={`before-you-scan-step-label${
                      step.muted ? ' before-you-scan-step-label--muted' : ''
                    }`}
                  >
                    {step.label}
                  </span>
                  {step.completed ? (
                    <span className="before-you-scan-done">
                      <CheckCircleOutlined />
                      {doneLabel}
                    </span>
                  ) : (
                    <ScopeButton
                      type="dark-orange"
                      width="100px"
                      height="32px"
                      onClick={step.onCta}
                      disabled={step.disabled}
                    >
                      {step.ctaLabel}
                    </ScopeButton>
                  )}
                </div>
              </div>
            </li>
          ))}
        </ul>
      </div>
      {illustrationSrc ? (
        <img
          className="before-you-scan-illustration"
          src={illustrationSrc}
          alt={illustrationAlt}
        />
      ) : null}
    </div>
  </div>
);
